import Vue from 'vue';
import Router from 'vue-router';

// common
const Login = () => import('../views/login/index.vue');
const NewPassword = () => import('../views/login/new_pswd.vue');
const CheckMobile = () => import('../views/login/check_mobile.vue');
const Layout = () => import('../views/layout.vue');
const wechatLoginCallback = () => import('../views/login/wechat_callback.vue');
const notFound = () => import('../views/404.vue');

// dealer
const Home = () => import('../views/home.vue');

const FinalCustomers = () => import('../views/customer/final.vue');
const AuthorizedCustomers = () => import('../views/customer/authorized.vue');
const OemCustomers = () => import('../views/customer/oem.vue');
const OrdinaryCustomers = () => import('../views/customer/ordinary.vue');
const OtherCustomers = () => import('../views/customer/other.vue');

const Customers = () => import('../views/customer/index.vue');
const DeletedCustomers = () => import('../views/customer/deleted.vue');
const RepeatCustomers = () => import('../views/customer/repeat.vue');
const CustomerDetail = () => import('../views/customer/detail.vue');

const CustomerDevices = () => import('../views/customer_device/index.vue');
const PendingCustomerDevices = () =>
  import('../views/customer_device/pending.vue');
const CustomerExportRecords = () =>
  import('../views/customer_export_record/index.vue');

const CustomerDeviceDelivery = () =>
  import('../views/customer_device/delivery.vue');

const CustomerUsers = () => import('../views/customer_user/index.vue');
const ApproveCustomerUsers = () =>
  import('../views/customer_user/approve_index.vue');
const Qrcodes = () => import('../views/customer_user/qrcode.vue');

const CampaignList = () => import('../views/campaign/index.vue');
const LeadsList = () => import('../views/leads/index.vue');

const CustomerOrders = () => import('../views/customer_order/index.vue');
const CustomerOrderDoneList = () => import('../views/customer_order/done.vue');
const CustomerOrderDeletedList = () =>
  import('../views/customer_order/deleted.vue');
const CustomerOrder = () => import('../views/customer_order/detail_v1.vue');

const CustomerConsultOrderList = () =>
  import('../views/customer_order/consult_index.vue');
const CustomerConsultOrderDoneList = () =>
  import('../views/customer_order/consult_done.vue');

const QuotationList = () => import('../views/quotation/index.vue');
const QuotationNew = () => import('../views/quotation/new.vue');
const QuotationDetail = () => import('../views/quotation/detail_v1.vue');
const QuotationDeletedList = () => import('../views/quotation/deleted.vue');
const QuotationDeletedDetail = () => import('../views/quotation/detail.vue');
const QuotationDoneList = () => import('../views/quotation/done.vue');
const QuotationDoneDetail = () => import('../views/quotation/detail.vue');

const PurchaseOrderList = () => import('../views/purchase_order/index.vue');
const PurchaseOrderDetail = () => import('../views/purchase_order/detail.vue');

const StoreIn = () => import('../views/store/stock_in.vue');
const StoreInHistory = () => import('../views/store/stock_in_history.vue');
const StoreOut = () => import('../views/store/stock_out.vue');
const StoreOutHistory = () => import('../views/store/stock_out_history.vue');
const StoreItems = () => import('../views/store/store_item.vue');
const StoreSet = () => import('../views/store/set.vue');

const SupplierList = () => import('../views/product/supplier/list.vue');
const ItemCategoryList = () =>
  import('../views/product/item_category/index.vue');
const ItemIndex = () => import('../views/product/item/index.vue');
const DeviceInfoIndex = () => import('../views/product/device_info/index.vue');
const DeviceCraftIndex = () => import('../views/product/craft/index.vue');

const DealerUsers = () => import('../views/dealer/users.vue');
const DealerGroups = () => import('../views/dealer/groups.vue');
const DealerGroupFlows = () => import('../views/dealer/flows.vue');
const DealerInfo = () => import('../views/dealer/info.vue');

const CustomerCoverage = () =>
  import('../views/statistics/customer_coverage.vue');
const QuotationConversion = () =>
  import('../views/statistics/quotation_conversion.vue');
const MonthSales = () => import('../views/statistics/month_sales.vue');
const TemplateEditor = () => import('../views/template/editor.vue');

const Message = () => import('../views/message/index.vue');

const Roles = () => import('../views/role/index.vue');
const Resource = () => import('../views/resource/index.vue');

const operationRecordList = () => import('../views/operation_record/index');

// platform
const AdminCustomers = () => import('../views/admin_customer/index.vue');
const AdminCustomerDetail = () => import('../views/admin_customer/detail.vue');

const DealerList = () => import('../views/dealers/list.vue');
const DealerDetail = () => import('../views/dealers/detail.vue');
const AdminUsers = () => import('../views/admin_users/index.vue');
const AdminUserDetail = () => import('../views/admin_users/detail.vue');

const VisitIndex = () => import('../views/visit/index.vue');
const CustomerIssueIndex = () => import('../views/customer/issue.vue');
const ServiceQuestNew = () => import('../views/service_quest/new.vue');
const ServiceQuestOngoing = () => import('../views/service_quest/ongoing.vue');
const ServiceQuestDetail = () => import('../views/service_quest/show.vue');
const ServiceQuestIndex = () => import('../views/service_quest/index.vue');
const ServiceQuestRepairIndex = () =>
  import('../views/service_quest/repair_index.vue');
// const ServiceQuestArchived = () => import('../views/service_quest/archived.vue')
const ServiceQuestComment = () => import('../views/service_quest/comment.vue');
const ServiceQuestGrab = () => import('../views/service_quest/grab.vue');
const ServiceQuestStatistics = () => import("../views/service_quest/statistics/index.vue")
const ServiceQuestStatisticsDetail = () => import("../views/service_quest/statistics/flow.vue")
const SecondhandNew = () => import('../views/service_quest/secondhand_new.vue');
const SecondhandOngoing = () =>
  import('../views/service_quest/secondhand_ongoing.vue');
const SecondhandArchived = () =>
  import('../views/service_quest/secondhand_archived.vue');
const ServiceQuestShare = () => import('../views/service_quest/share.vue');
const ServiceQuestMPPage = () => import('../views/service_quest/mp_page.vue');
const CcmCategoryList = () => import('../views/ccm_category/index.vue');
const ServiceQuestFlowList = () =>
  import('../views/service_quest/flow/index.vue');
const ServiceQuestConfig = () => import('../views/service_quest/config.vue');

const EffectiveDevice = () =>
  import('../views/statistics/effective_device.vue');

const NoticeList = () => import('../views/notice/manage/index.vue');
const NoticeDetail = () => import('../views/notice/manage/detail.vue');
const NoticeUserSelect = () => import('../views/notice/manage/user_select.vue');
const UserNoticeList = () => import('../views/notice/user_notice/index.vue');
const UserNoticeDetail = () => import('../views/notice/user_notice/detail.vue');
const NoticeCategoryList = () => import('../views/notice/category/index.vue');

const RepositoryList = () => import('../views/repository/index.vue');
const RepositoryDetail = () => import('../views/repository/detail.vue');

const UsedDeviceIndex = () => import('../views/used_device/index.vue');
const UsedDeviceSold = () => import('../views/used_device/sold.vue');
const UsedDeviceSale = () => import('../views/used_device/sale.vue');
const DeviceQuestBuying = () => import('../views/device_quest/buying.vue');
const DeviceQuestRecycle = () => import('../views/device_quest/recycle.vue');

const ProductPromotionAdmin = () => import('../views/product_promotion/admin');
const ProductPromotionHistory = () =>
  import('../views/product_promotion/history');
const ProductPromotionPromoting = () =>
  import('../views/product_promotion/promoting');

const SmsRecordList = () => import('../views/sms/list.vue');
const SmsSend = () => import('../views/sms/send.vue');

const DeliveryToDevice = () => import('../views/tool/delivery_to_device.vue');

const ShopAdminItemList = () => import('../views/shop/admin_items');
const CommodityPriceList = () => import('../views/shop/admin_items/price');
const CommodityPhList = () => import('../views/shop/commodity_ph/index');
const CommodityActivityList = () => import('../views/wikis/activity');
const CommodityVersionList = () => import('../views/shop/admin_items/version');
const DealderStagePrice = () => import('../views/shop/dealer_price');
const ShopFlowSet = () => import('../views/shop/flow_set');
const CommodityCategoryList = () =>
  import('../views/shop/commodity_category_v1/index');
const CommodityList = () => import('../views/shop/commodity/index');
const CartList = () => import('../views/shop/cart/index');

const OrderConfirm = () => import('../views/shop/order/confirm');
const commodityOrderList = () => import('../views/shop/order/index');

const BannerList = () => import('../views/shop/banner/index');

const commodityApplicationOrderList = () =>
  import('../views/shop/order/application');
const commodityApproveOrderList = () => import('../views/shop/order/approve');
const commodityPendingOrderList = () => import('../views/shop/order/pending');
const commodityPayedOrderList = () => import('../views/shop/order/payed');
const commodityDoneOrderList = () => import('../views/shop/order/done');
const commodityInvalidOrderList = () => import('../views/shop/order/invalid');

const commodityOrderShow = () => import('../views/shop/order/show');
const commodityOrderEdior = () => import('../views/shop/order/edior');

const wikiList = () => import('../views/wikis/doc');
const wikiShow = () => import('../views/wikis/show');
const wikiCommentList = () => import('../views/wiki_comment/index');

const customConfigIndex = () => import('../views/custom_config/index');
const maintainanceRuleIndex = () => import('../views/maintainance_rule/index');

const DeviceMaintainanceIndex = () => import('../views/device_maintainance/index');


const deployIndex = () => import('../views/deploy/index');

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

export const constantRoutes = [
  {
    path: '/',
    name: 'Index',
    redirect: '/dashboard',
  },
  {
    path: '/login',
    name: '登陆',
    component: Login,
  },
  {
    path: '/check_mobile',
    name: '手机验证',
    component: CheckMobile,
  },
  {
    path: '/setpswd',
    name: '重设密码',
    component: NewPassword,
  },
  {
    path: '/wechat/callback',
    component: wechatLoginCallback,
    meta: { title: '微信登录' },
  },
  {
    path: '/sqs/:uuid',
    component: ServiceQuestShare,
    meta: { title: '服务请求详情' },
  },
  {
    path: '/service_orders/:uuid',
    component: ServiceQuestMPPage,
    meta: { title: '跳转中' },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Layout,
    children: [
      {
        path: 'deploy',
        name: 'deploy',
        component: deployIndex,
      },
      {
        path: 'visits',
        name: 'visits',
        component: VisitIndex,
        meta: { authName: 'customerFollowUpList' },
      },
      {
        path: 'customer_issues',
        name: 'customer_issue',
        component: CustomerIssueIndex,
        meta: { authName: 'customerIssueList' },
      },
      {
        path: 'admin/customer_devices',
        name: 'customer_device',
        component: CustomerDevices,
        meta: { authName: 'customerDeviceList' },
      },
      {
        path: 'admin/pending_customer_devices',
        name: 'pending_customer_device',
        component: PendingCustomerDevices,
        meta: { authName: 'customerDeviceList' },
      },
      {
        path: 'admin/device_maintainances',
        name: 'device_maintainance',
        component: DeviceMaintainanceIndex,
        meta: { authName: 'customerDeviceMaintentanceList' },
      },
      {
        path: 'admin/customer_device_deliveries',
        name: 'customer_device_delivery',
        component: CustomerDeviceDelivery,
        meta: { authName: 'customerDeviceDeliveryList' },
      },
      {
        path: 'admin/customer_users',
        name: 'customer_user',
        component: CustomerUsers,
        meta: { authName: 'customerUserList' },
      },
      {
        path: 'admin/customer_users/approve',
        name: 'customer_user_approve',
        component: ApproveCustomerUsers,
        meta: { authName: 'customerUserList' },
      },
      {
        path: 'admin/qrcodes',
        name: 'qrcode',
        component: Qrcodes,
        meta: { authName: 'qrcodeList' },
      },
      {
        path: 'customer_export_records',
        name: 'customer_export_record',
        component: CustomerExportRecords,
        meta: { authName: 'customerExportRecordList' },
      },
      {
        path: 'messages',
        name: 'mesages',
        component: Message,
      },
      {
        path: 'admin/dealers',
        name: 'dealer',
        component: DealerList,
        meta: { authName: 'dealerList' },
      },
      {
        path: 'admin/dealers/:id',
        name: 'dealer',
        component: DealerDetail,
        meta: { authName: 'dealerShow' },
      },
      {
        path: 'admin/item_categories',
        name: 'item_category',
        component: ItemCategoryList,
        meta: { authName: 'productCategoryList' },
      },
      {
        path: 'admin/users',
        name: 'user',
        component: AdminUsers,
        meta: { authName: 'userList' },
      },
      {
        path: 'admin/users/:id',
        name: 'user',
        component: AdminUserDetail,
        meta: { authName: 'userShow' },
      },
      {
        path: 'admin/roles',
        name: 'role',
        component: Roles,
        meta: { authName: 'roleList' },
      },

      {
        path: 'admin/resources',
        name: 'resource',
        component: Resource,
        meta: { authName: 'resourceSetting' },
      },

      {
        path: 'admin/operation_records',
        name: 'operation_record',
        component: operationRecordList,
        meta: { authName: 'operationRecord' },
      },

      {
        path: 'home',
        name: 'home',
        component: Home,
        meta: { authName: '' },
      },
      {
        path: 'dealer/purchase_orders',
        name: 'purchase_order',
        component: PurchaseOrderList,
        meta: { authName: 'purchaseOrderList' },
      },
      {
        path: 'dealer/purchase_orders/:id',
        name: 'purchase_order',
        component: PurchaseOrderDetail,
        meta: { authName: 'purchaseOrderShow' },
      },
      {
        path: 'customers',
        name: 'customer',
        component: Customers,
        meta: { authName: 'customerList' },
      },
      {
        path: 'final_customers',
        name: 'finalCustomer',
        component: FinalCustomers,
        meta: { authName: 'customerList' },
      },
      {
        path: 'authorized_customers',
        name: 'authorizedCustomer',
        component: AuthorizedCustomers,
        meta: { authName: 'customerList' },
      },
      {
        path: 'oem_customers',
        name: 'oemCustomer',
        component: OemCustomers,
        meta: { authName: 'customerList' },
      },
      {
        path: 'ordinary_customers',
        name: 'ordinaryCustomer',
        component: OrdinaryCustomers,
        meta: { authName: 'customerList' },
      },
      {
        path: 'other_customers',
        name: 'otherCustomer',
        component: OtherCustomers,
        meta: { authName: 'customerList' },
      },
      {
        path: 'final_customers/:id',
        name: 'finalCustomer',
        component: CustomerDetail,
        meta: { authName: 'customerShow' },
      },
      {
        path: 'authorized_customers/:id',
        name: 'authorizedCustomer',
        component: CustomerDetail,
        meta: { authName: 'customerShow' },
      },
      {
        path: 'oem_customers/:id',
        name: 'oemCustomer',
        component: CustomerDetail,
        meta: { authName: 'customerShow' },
      },
      {
        path: 'Ordinary_customers/:id',
        name: 'ordinaryCustomer',
        component: CustomerDetail,
        meta: { authName: 'customerShow' },
      },
      {
        path: 'other_customers/:id',
        name: 'otherCustomer',
        component: CustomerDetail,
        meta: { authName: 'customerShow' },
      },
      {
        path: 'customers/deleted',
        name: 'customerDeleted',
        component: DeletedCustomers,
        meta: { authName: 'customerDeletedList' },
      },
      {
        path: 'customers/repeat',
        name: 'customerRepeat',
        component: RepeatCustomers,
        meta: { authName: 'customerRepeatList' },
      },
      {
        path: 'customers/:id',
        name: 'customer',
        component: CustomerDetail,
        meta: { authName: 'customerShow' },
      },
      {
        path: 'customers/deleted/:id',
        name: 'customerDeleted',
        component: CustomerDetail,
        meta: { authName: 'customerDeletedShow' },
      },
      {
        path: 'customers/repeat/:id',
        name: 'customerRepeat',
        component: CustomerDetail,
        meta: { authName: 'customerRepeatShow' },
      },
      {
        path: 'campaigns',
        name: 'campaign',
        component: CampaignList,
        meta: { authName: 'campaignList' },
      },
      {
        path: 'leads',
        name: 'leads',
        component: LeadsList,
        meta: { authName: 'leadsList' },
      },
      {
        path: 'quotations',
        name: 'quotation',
        component: QuotationList,
        meta: { authName: 'quotationList' },
      },
      {
        path: 'quotations/:id',
        name: 'quotation',
        component: QuotationDetail,
        meta: { authName: 'quotationShow' },
      },
      {
        path: 'deleted/quotations',
        name: 'quotationDeleted',
        component: QuotationDeletedList,
        meta: { authName: 'quotationList' },
      },
      {
        path: 'deleted/quotations/:id',
        name: 'quotationDeleted',
        component: QuotationDeletedDetail,
        meta: { authName: 'quotationShow' },
      },
      {
        path: 'done/quotations',
        name: 'quotationDone',
        component: QuotationDoneList,
        meta: { authName: 'quotationList' },
      },
      {
        path: 'done/quotations/:id',
        name: 'quotationDone',
        component: QuotationDoneDetail,
        meta: { authName: 'quotationShow' },
      },
      {
        path: 'store/store_items',
        name: 'store_item',
        component: StoreItems,
        meta: { authName: 'storeItemList' },
      },
      {
        path: 'store/stock_in',
        redirect: 'store/stock_in/index',
        meta: { authName: 'stockInList' },
      },
      {
        path: 'store/stock_in/index',
        name: 'stock_in',
        component: StoreIn,
        meta: { authName: 'stockInList' },
      },
      {
        path: 'store/stock_in/history',
        name: 'stock_in_history',
        component: StoreInHistory,
        meta: { authName: 'stockInList' },
      },
      {
        path: 'store/stock_out',
        redirect: 'store/stock_out/index',
        meta: { authName: 'stockOutList' },
      },
      {
        path: 'store/stock_out/index',
        name: 'stock_out',
        component: StoreOut,
        meta: { authName: 'stockOutList' },
      },
      {
        path: 'store/stock_out/history',
        name: 'stock_out_history',
        component: StoreOutHistory,
        meta: { authName: 'stockOutList' },
      },
      {
        path: 'store/set',
        name: 'store_set',
        component: StoreSet,
        meta: { authName: 'stockroomList' },
      },
      {
        path: 'dealer/suppliers',
        name: 'supplier',
        component: SupplierList,
        meta: { authName: 'supplierList' },
      },
      {
        path: 'dealer/item_categories',
        name: 'item_category',
        component: ItemCategoryList,
        meta: { authName: 'productCategoryList' },
      },
      {
        path: 'dealer/items',
        name: 'item',
        component: ItemIndex,
        meta: { authName: 'productList' },
      },
      {
        path: 'dealer/device_info',
        name: 'device_info',
        component: DeviceInfoIndex,
        meta: { authName: 'deviceGroupList' },
      },
      {
        path: 'device_craft',
        name: 'device_craft',
        component: DeviceCraftIndex,
        meta: { authName: 'deviceCraftList' },
      },
      {
        path: 'custom_configs',
        name: 'custom_config',
        component: customConfigIndex,
        meta: { authName: 'customConfigList' },
      },
      {
        path: 'maintainance_rules',
        name: 'maintainance_rule',
        component: maintainanceRuleIndex,
        meta: { authName: 'maintainanceRuleList' },
      },
      // {
      //   path: 'dealer/users',
      //   name: 'dealer_user',
      //   component: DealerUsers,
      //   meta: { authName: 'dealerUserList' }
      // },
      {
        path: 'dealer/groups',
        name: 'dealer_group',
        component: DealerGroups,
        meta: { authName: 'groupList' },
      },
      {
        path: 'dealer/flows',
        name: 'dealer_flows',
        component: DealerGroupFlows,
        meta: { authName: 'flowList' },
      },
      {
        path: 'dealer/Info',
        name: 'dealer_info',
        component: DealerInfo,
        meta: { authName: 'dealerInfo' },
      },
      {
        path: 'dealer/templates/editor',
        name: 'TemplateEditor',
        component: TemplateEditor,
        meta: { authName: '' },
      },
      {
        path: 'dealer/orders',
        name: 'order',
        component: CustomerOrders,
        meta: { authName: 'orderList' },
      },
      {
        path: 'dealer/deleted/orders',
        name: 'orderDeleted',
        component: CustomerOrderDeletedList,
        meta: { authName: 'orderList' },
      },
      {
        path: 'dealer/deleted/orders/:id',
        name: 'orderDeleted',
        component: CustomerOrder,
        meta: { authName: 'orderShow' },
      },
      {
        path: 'dealer/done/orders',
        name: 'orderDone',
        component: CustomerOrderDoneList,
        meta: { authName: 'orderList' },
      },
      {
        path: 'dealer/done/orders/:id',
        name: 'orderDone',
        component: CustomerOrder,
        meta: { authName: 'orderShow' },
      },
      {
        path: 'dealer/orders/:id',
        name: 'order',
        component: CustomerOrder,
        meta: { authName: 'orderShow' },
      },
      {
        path: 'customer/orders',
        name: 'consultOrder',
        component: CustomerConsultOrderList,
        meta: { authName: 'orderList' },
      },
      {
        path: 'customer/done/orders',
        name: 'consultOrderDone',
        component: CustomerConsultOrderDoneList,
        meta: { authName: 'orderList' },
      },
      {
        path: 'customer/orders/:id',
        name: 'consultOrder',
        component: CustomerOrder,
        meta: { authName: 'orderShow' },
      },
      {
        path: 'customer/done/orders/:id',
        name: 'consultOrderDone',
        component: CustomerOrder,
        meta: { authName: 'orderShow' },
      },
      {
        path: 'new_quotation',
        name: 'quotation',
        component: QuotationNew,
        meta: { authName: 'quotationNew' },
      },
      {
        path: 'service_quests/new',
        name: 'service_quests_new',
        component: ServiceQuestNew,
        meta: { authName: 'serviceQuestList' },
      },
      {
        path: 'service_quests/new/:id',
        name: 'service_quests_new',
        component: ServiceQuestDetail,
        meta: { authName: 'serverQuestDetail' },
      },
      {
        path: 'service_quests/list',
        name: 'service_quests_list',
        component: ServiceQuestIndex,
        meta: { authName: 'serviceQuestList' },
      },
      {
        path: 'service_quests/list/:id',
        name: 'service_quests_list',
        component: ServiceQuestDetail,
        meta: { authName: 'serverQuestDetail' },
      },
      {
        path: 'dealer_service_quests/list',
        name: 'dealer_service_quests_list',
        component: ServiceQuestIndex,
        meta: { authName: 'serviceQuestDealerList' },
      },
      {
        path: 'dealer_service_quests/list/:id',
        name: 'dealer_service_quests_list',
        component: ServiceQuestDetail,
        meta: { authName: 'serverQuestDetail' },
      },
      {
        path: 'service_quests/comment',
        name: 'service_quests_comment',
        component: ServiceQuestComment,
        meta: { authName: 'serverQuestComentList' },
      },
      {
        path: 'service_quests/grab',
        name: 'service_quests_grab',
        component: ServiceQuestGrab,
        meta: { authName: 'serviceQuestFlowCFSDoorService' },
      },
      {
        path: 'service_quests/grab/:id',
        name: 'service_quests_grab',
        component: ServiceQuestDetail,
        meta: { authName: 'serverQuestDetail' },
      },
      {
        path: 'repair_service_quests/list',
        name: 'repair_service_quests_list',
        component: ServiceQuestRepairIndex,
        meta: { authName: 'serviceQuestRepairList' },
      },
      {
        path: 'repair_service_quests/list/:id',
        name: 'repair_service_quests_list',
        component: ServiceQuestDetail,
        meta: { authName: 'serverQuestDetail' },
      },
      {
        path: 'service_quests/my',
        name: 'service_quests_ongoing',
        component: ServiceQuestOngoing,
        meta: { authName: 'serviceQuestList' },
      },
      {
        path: 'service_quests/my/:id',
        name: 'service_quests_ongoing',
        component: ServiceQuestDetail,
        meta: { authName: 'serverQuestDetail' },
      },
      // {
      //   path: 'service_quests/archived',
      //   name: 'service_quests_archived',
      //   component: ServiceQuestArchived,
      //   meta: { authName: 'serviceQuestList' }
      // },
      {
        path: 'service_quests/archived/:id',
        name: 'service_quests_archived',
        component: ServiceQuestDetail,
        meta: { authName: 'serverQuestDetail' },
      },
      {
        path: 'service_quests/statistics',
        name: 'service_quests_statistics',
        component: ServiceQuestStatistics,
        meta: { authName: 'serviceQuestStatistics' },
      },
      {
        path: 'service_quests/statistics/:id',
        name: 'service_quests_statistics',
        component: ServiceQuestStatisticsDetail,
        meta: { authName: 'serviceQuestStatistics' },
      },
      {
        path: 'secondhands/new',
        name: 'secondhands_new',
        component: SecondhandNew,
        meta: { authName: 'serviceQuestList' },
      },
      {
        path: 'secondhands/new/:id',
        name: 'secondhands_new',
        component: ServiceQuestDetail,
        meta: { authName: 'serverQuestDetail' },
      },
      {
        path: 'secondhands/processing',
        name: 'secondhands_ongoing',
        component: SecondhandOngoing,
        meta: { authName: 'serviceQuestList' },
      },
      {
        path: 'secondhands/processing/:id',
        name: 'secondhands_ongoing',
        component: ServiceQuestDetail,
        meta: { authName: 'serverQuestDetail' },
      },
      {
        path: 'secondhands/archived',
        name: 'secondhands_archived',
        component: SecondhandArchived,
        meta: { authName: 'serviceQuestList' },
      },
      {
        path: 'secondhands/archived/:id',
        name: 'secondhands_archived',
        component: ServiceQuestDetail,
        meta: { authName: 'serverQuestDetail' },
      },
      {
        path: 'ccm_categories',
        name: 'ccm_category_list',
        component: CcmCategoryList,
        meta: { authName: 'ccmCategoryList' },
      },
      {
        path: 'service_quest_flows',
        name: 'serviec_quest_flow',
        component: ServiceQuestFlowList,
        meta: { authName: 'serviceQuestFlowList' },
      },
      {
        path: 'service_quest_config',
        name: 'serviec_quest_config',
        component: ServiceQuestConfig,
        meta: { authName: 'serviceQuestFlowList' },
      },
      {
        path: 'order_editor',
        name: 'order',
        component: QuotationNew,
        meta: { authName: 'orderNew' },
      },
      {
        path: 'consult_order_editor',
        name: 'consultOrder',
        component: QuotationNew,
        meta: { authName: 'orderNew' },
      },
      {
        path: 'dealer/statistics/coverage',
        name: 'coverage',
        component: CustomerCoverage,
        meta: { authName: 'customerCoverage' },
      },
      {
        path: 'dealer/statistics/conversion',
        name: 'conversion',
        component: QuotationConversion,
        meta: { authName: 'quotationConversion' },
      },
      {
        path: 'dealer/statistics/month_sales',
        name: 'month_sales',
        component: MonthSales,
        meta: { authName: '' },
      },
      {
        path: 'statistics/effective_device',
        name: 'effective_device',
        component: EffectiveDevice,
        meta: { authName: 'effectiveDeviceList' },
      },
      {
        path: 'notices',
        name: 'notice_manage',
        component: NoticeList,
        meta: { authName: 'noticeList', status: 3 },
      },
      {
        path: 'notice_categories',
        name: 'notice_category',
        component: NoticeCategoryList,
        meta: { authName: 'noticeCategoryList' },
      },
      {
        path: 'notices/:id',
        name: 'notice_manage',
        component: NoticeDetail,
        meta: { authName: 'noticeShow' },
      },
      {
        path: 'notices/:id/user_select',
        name: 'notice_manage',
        component: NoticeUserSelect,
        meta: { authName: 'noticeNew' },
      },
      {
        path: 'notice_approve',
        name: 'notice_approve',
        component: NoticeList,
        meta: { authName: 'noticeList', status: 2 },
      },
      {
        path: 'notice_approve/:id',
        name: 'notice_approve',
        component: NoticeDetail,
        meta: { authName: 'noticeShow' },
      },
      {
        path: 'notice_history',
        name: 'notice_history',
        component: NoticeList,
        meta: { authName: 'noticeList', status: 1 },
      },
      {
        path: 'notice_history/:id',
        name: 'notice_history',
        component: NoticeDetail,
        meta: { authName: 'noticeShow' },
      },
      {
        path: 'user_notices',
        name: 'user_notice',
        component: UserNoticeList,
        meta: { authName: 'userNotice' },
      },
      {
        path: 'notices/detail/:id',
        name: 'user_notice',
        component: UserNoticeDetail,
        meta: { authName: 'userNotice' },
      },
      {
        path: 'user_repositories',
        name: 'user_repository',
        component: RepositoryList,
        meta: { authName: 'userRepository' },
      },
      {
        path: 'user_repositories/:id',
        name: 'user_repository',
        component: RepositoryDetail,
        meta: { authName: 'userRepository' },
      },
      {
        path: 'repositories',
        name: 'repository_manage',
        component: RepositoryList,
        meta: { authName: 'repositoryList' },
      },
      {
        path: 'repositories/:id',
        name: 'repository_manage',
        component: RepositoryDetail,
        meta: { authName: 'repositoryShow' },
      },
      {
        path: 'used_devices',
        name: 'used_device_index',
        component: UsedDeviceIndex,
        meta: { authName: 'usedDeviceAdminList' },
      },
      {
        path: 'used_devices/sold',
        name: 'used_device_sold',
        component: UsedDeviceSold,
        meta: { authName: 'usedDeviceAdminList' },
      },
      {
        path: 'used_devices/sale',
        name: 'used_device_sale',
        component: UsedDeviceSale,
        meta: { authName: 'usedDeviceSaleList' },
      },
      {
        path: 'device_quests/buying',
        name: 'device_quest_buying',
        component: DeviceQuestBuying,
        meta: { authName: 'deviceQuestList' },
      },
      {
        path: 'device_quests/recycle',
        name: 'device_quest_recycle',
        component: DeviceQuestRecycle,
        meta: { authName: 'deviceQuestList' },
      },
      {
        path: 'promotions/admin',
        name: 'product_promotion_admin',
        component: ProductPromotionAdmin,
        meta: { authName: 'productPromotionList' },
      },
      {
        path: 'promotions/history',
        name: 'product_promotion_history',
        component: ProductPromotionHistory,
        meta: { authName: 'productPromotionList' },
      },
      {
        path: 'promotions/promoting',
        name: 'product_promotion_promoting',
        component: CommodityList,
        meta: { authName: 'commodityList' },
      },
      {
        path: 'shop/banners',
        name: 'banner',
        component: BannerList,
        meta: { authName: 'bannerList' },
      },
      {
        path: 'sms/records',
        name: 'sms_records',
        component: SmsRecordList,
        meta: { authName: 'smsRecord' },
      },
      {
        path: 'sms/send',
        name: 'sms_send',
        component: SmsSend,
        meta: { authName: 'smsSend' },
      },
      {
        path: 'tool/delivery_to_device',
        name: 'delivery_to_device',
        component: DeliveryToDevice,
        meta: { authName: 'deliveryToDevice' },
      },
      {
        path: 'shop/item_admin',
        name: 'shop_item_admin',
        component: ShopAdminItemList,
        meta: { authName: 'commodityAdmin' },
      },
      {
        path: 'shop/commodity_versions',
        name: 'shop_item_admin',
        component: CommodityVersionList,
        meta: { authName: 'commodityAdmin' },
      },
      {
        path: 'shop/dealer_stage_price',
        name: 'dealder_stage_price',
        component: DealderStagePrice,
        meta: { authName: 'dealerStageDiscountList' },
      },
      {
        path: 'shop/flow_set',
        name: 'shop_flow_set',
        component: ShopFlowSet,
        meta: { authName: 'shopFlowList' },
      },
      {
        path: 'shop/commodity_categories',
        name: 'commodity_category',
        component: CommodityCategoryList,
        meta: { authName: 'commodityCategoryList' },
      },
      {
        path: 'shop/commodity_prices',
        name: 'commodity_price',
        component: CommodityPriceList,
        meta: { authName: 'commodityPriceList' },
      },
      {
        path: 'shop/commodity_phs',
        name: 'commodity_ph',
        component: CommodityPhList,
        meta: { authName: 'commodityPhList' },
      },
      {
        path: 'shop/activities',
        name: 'shop_activity',
        component: CommodityActivityList,
        meta: { authName: 'commodityActivityList' },
      },
      {
        path: 'shop/commodities',
        name: 'commodity',
        component: CommodityList,
        meta: { authName: 'commodityList' },
      },
      {
        path: 'shop/carts',
        name: 'cart',
        component: CartList,
        meta: { authName: 'commodityOrderManage' },
      },
      {
        path: 'shop/orders/confirm',
        name: 'cart',
        component: OrderConfirm,
        meta: { authName: 'commodityOrderManage' },
      },
      {
        path: 'shop/orders/editor',
        name: 'commodity_application_order',
        component: commodityOrderEdior,
        meta: { authName: 'commodityOrderItemUpdate' },
      },
      {
        path: 'shop/orders',
        name: 'commodity_order',
        component: commodityOrderList,
        meta: { authName: 'commodityOrderList' },
      },
      {
        path: 'shop/application_orders',
        name: 'commodity_application_order',
        component: commodityApplicationOrderList,
        meta: { authName: 'commodityOrderItemUpdate', status: 0 },
      },
      {
        path: 'shop/approve_orders',
        name: 'commodity_approve_order',
        component: commodityApproveOrderList,
        meta: { authName: 'commodityOrderList', status: 2 },
      },
      {
        path: 'shop/pending_orders',
        name: 'commodity_pending_order',
        component: commodityPendingOrderList,
        meta: { authName: 'commodityOrderList', status: 5 },
      },
      {
        path: 'shop/payed_orders',
        name: 'commodity_payed_order',
        component: commodityPayedOrderList,
        meta: { authName: 'commodityOrderList', status: 6 },
      },
      {
        path: 'shop/invalid_orders',
        name: 'commodity_invalid_order',
        component: commodityInvalidOrderList,
        meta: { authName: 'commodityOrderList', status: 1 },
      },
      {
        path: 'shop/done_orders',
        name: 'commodity_done_order',
        component: commodityDoneOrderList,
        meta: { authName: 'commodityOrderList', status: 100 },
      },
      {
        path: 'shop/orders/:id',
        name: 'commodity_order',
        component: commodityOrderShow,
        meta: { authName: 'commodityOrderDetail' },
      },
      {
        path: 'shop/approve_orders/:id',
        name: 'commodity_approve_order',
        component: commodityOrderShow,
        meta: { authName: 'commodityOrderDetail' },
      },
      {
        path: 'shop/application_orders/:id',
        name: 'commodity_application_order',
        component: commodityOrderShow,
        meta: { authName: 'commodityOrderDetail' },
      },
      {
        path: 'shop/pending_orders/:id',
        name: 'commodity_pending_order',
        component: commodityOrderShow,
        meta: { authName: 'commodityOrderDetail' },
      },
      {
        path: 'shop/payed_orders/:id',
        name: 'commodity_payed_order',
        component: commodityOrderShow,
        meta: { authName: 'commodityOrderDetail' },
      },
      {
        path: 'shop/done_orders/:id',
        name: 'commodity_done_order',
        component: commodityOrderShow,
        meta: { authName: 'commodityOrderDetail' },
      },
      {
        path: 'shop/invalid_orders/:id',
        name: 'commodity_invalid_order',
        component: commodityOrderShow,
        meta: { authName: 'commodityOrderDetail' },
      },
      {
        path: 'wikis',
        name: 'wiki',
        component: wikiList,
        meta: { authName: 'wikiList' },
      },
      {
        path: 'wikis/:id',
        name: 'wiki',
        component: wikiShow,
        meta: { authName: 'wikiList' },
      },
      {
        path: 'wiki_comments',
        name: 'wiki_comment',
        component: wikiCommentList,
        meta: { authName: 'wikiCommentList' },
      },
    ],
  },
  {
    path: '*',
    component: notFound,
    meta: { title: '404' },
  },
];

export function hasPermission(auths, route) {
  if (route.meta && route.meta.authName) {
    return auths.some((auth) => route.meta.authName == auth);
  } else {
    return true;
  }
}

export function filterAsyncRoutes(routes, auths) {
  const res = [];

  routes.forEach((route) => {
    const tmp = { ...route };
    if (hasPermission(auths, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, auths);
      }
      res.push(tmp);
    }
  });

  return res;
}

export function accessRoutes(auths) {
  // const routes = filterAsyncRoutes(asyncRoutes, auths)
  const routes = asyncRoutes;
  return routes;
}

const createRouter = () =>
  new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: constantRoutes,
    scrollBehavior(to, from, savedPosition) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (savedPosition) {
            resolve(savedPosition);
            return;
          }
          resolve({ x: 0, y: 0 });
        }, 500);
      });
    },
  });

export const createNewRouter = () =>
  new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: constantRoutes,
  });

const router = createRouter();
export default router;
